var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: ".05rem 0 0 .05rem", height: ".15rem" } },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "vTitle flex" },
          [
            _c("img", {
              staticClass: "titleimg",
              attrs: { src: require("images/components/vtitleh.png"), alt: "" },
            }),
            _vm._t("default"),
          ],
          2
        ),
        _c("img", {
          staticClass: "titleI",
          attrs: { src: require("images/components/vtitle.png"), alt: "" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }